import Constant from '@/const';
import axios from 'axios';

const postOperationMarking = async (idEMR, payload) => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/document/medical-treatment/${idEMR}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postOperationMarking;
